import React, {useEffect} from 'react';
import Footer from './components/Footer';
import Header from './components/Header';
import Contact from './components/Contact';
import Links from './components/Links';
import Skills from './components/Skills';
import About from './components/About';
import Projects from './components/Projects';
import SkipToContent from './components/SkipToContent.js';

import ReactGA from 'react-ga';

function App() {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ID);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  return (
    <div className="flex flex-col items-stretch w-full h-full">
      <SkipToContent />
      <Header />

      <main className="flex-grow flex-shrink-0 m-5">
        <section className="w-full">
          <img
            className="w-56 ml-auto mr-auto rounded-full"
            src={require('./profile.jpg')}
            alt="headshot of joshua rieth"
          />
        </section>

        <About />
        <Skills />
        <Projects />
        <Links />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
